<div class="login-container">
  <div class="setup-card">

    <!-- Logo -->
    <div class="logo-section">
      <img src="assets/befret_logo.png" alt="BeFret" class="logo-img">
      <p class="brand-subtitle">Configuration 2FA obligatoire</p>
    </div>

    <!-- Steps indicator -->
    <div class="steps-bar">
      <div class="step-dot" [class.active]="step >= 0" [class.done]="step > 0">
        <span>1</span>
      </div>
      <div class="step-line" [class.active]="step > 0"></div>
      <div class="step-dot" [class.active]="step >= 1" [class.done]="step > 1">
        <span>2</span>
      </div>
      <div class="step-line" [class.active]="step > 1"></div>
      <div class="step-dot" [class.active]="step >= 2" [class.done]="step > 2">
        <span>3</span>
      </div>
      <div class="step-line" [class.active]="step > 2"></div>
      <div class="step-dot" [class.active]="step >= 3">
        <span>4</span>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading && step === 1" class="loading-state">
      <i class="fas fa-spinner fa-spin"></i>
      <p>Pr&eacute;paration de la configuration...</p>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage" class="alert alert-error">
      <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
    </div>

    <!-- ═══ STEP 0: Introduction ═══ -->
    <div *ngIf="step === 0">
      <div class="intro-icon">
        <i class="fas fa-shield-alt"></i>
      </div>
      <h2 class="step-title">S&eacute;curisez votre compte</h2>
      <p class="step-desc">
        La v&eacute;rification en deux &eacute;tapes (2FA) prot&egrave;ge votre acc&egrave;s au backoffice.
        En plus de votre mot de passe, vous devrez entrer un code g&eacute;n&eacute;r&eacute;
        par une application sur votre t&eacute;l&eacute;phone.
      </p>

      <div class="intro-requirement">
        <i class="fas fa-mobile-alt"></i>
        <div>
          <strong>Vous aurez besoin d'une application d'authentification</strong>
          <p>Installez l'une de ces applications gratuites sur votre t&eacute;l&eacute;phone :</p>
        </div>
      </div>

      <div class="app-list">
        <div class="app-item">
          <i class="fab fa-google"></i>
          <div class="app-info">
            <strong>Google Authenticator</strong>
            <div class="app-links">
              <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="noopener">
                <i class="fab fa-google-play"></i> Android
              </a>
              <a href="https://apps.apple.com/app/google-authenticator/id388497605" target="_blank" rel="noopener">
                <i class="fab fa-apple"></i> iPhone
              </a>
            </div>
          </div>
        </div>
        <div class="app-item">
          <i class="fas fa-key"></i>
          <div class="app-info">
            <strong>Microsoft Authenticator</strong>
            <div class="app-links">
              <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" rel="noopener">
                <i class="fab fa-google-play"></i> Android
              </a>
              <a href="https://apps.apple.com/app/microsoft-authenticator/id983156458" target="_blank" rel="noopener">
                <i class="fab fa-apple"></i> iPhone
              </a>
            </div>
          </div>
        </div>
      </div>

      <button class="btn btn-primary" (click)="goToQrStep()">
        <i class="fas fa-check"></i> J'ai install&eacute; l'application
      </button>
    </div>

    <!-- ═══ STEP 1: QR Code ═══ -->
    <div *ngIf="step === 1 && !loading">
      <h2 class="step-title">Scannez le QR Code</h2>
      <p class="step-desc">
        Ouvrez votre application d'authentification
        (Google Authenticator, Authy, Microsoft Authenticator)
        et scannez le QR code ci-dessous.
      </p>

      <div class="qr-container" *ngIf="qrImageDataUrl">
        <img [src]="qrImageDataUrl" alt="QR Code 2FA" class="qr-image">
      </div>

      <div class="manual-key-section">
        <p class="manual-label">Impossible de scanner ? Entrez cette cl&eacute; manuellement :</p>
        <div class="manual-key-box">
          <code>{{ manualKey }}</code>
          <button class="copy-btn" (click)="copyManualKey()" title="Copier">
            <i class="fas fa-copy"></i>
          </button>
        </div>
      </div>

      <button class="btn btn-primary" (click)="goToVerify()">
        <i class="fas fa-arrow-right"></i> J'ai scann&eacute; le QR code
      </button>
    </div>

    <!-- ═══ STEP 2: Verify ═══ -->
    <div *ngIf="step === 2">
      <h2 class="step-title">V&eacute;rifiez le code</h2>
      <p class="step-desc">
        Entrez le code &agrave; 6 chiffres affich&eacute; dans votre application d'authentification
        pour confirmer la configuration.
      </p>

      <div class="form-group">
        <label class="form-label">Code de v&eacute;rification</label>
        <input type="tel"
               [(ngModel)]="verifyCode"
               class="form-control code-input"
               placeholder="000000"
               maxlength="6"
               autocomplete="one-time-code"
               (keyup.enter)="onVerifyAndEnable()">
      </div>

      <button class="btn btn-primary"
              [disabled]="loading || verifyCode.trim().length < 6"
              (click)="onVerifyAndEnable()">
        <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>
        <i class="fas fa-check" *ngIf="!loading"></i>
        {{ loading ? 'V\u00e9rification...' : 'Activer le 2FA' }}
      </button>

      <button class="btn-back" (click)="step = 1">
        <i class="fas fa-arrow-left"></i> Retour au QR code
      </button>
    </div>

    <!-- ═══ STEP 3: Backup Codes ═══ -->
    <div *ngIf="step === 3">
      <div class="success-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <h2 class="step-title">2FA activ&eacute; !</h2>
      <p class="step-desc">
        Sauvegardez vos <strong>codes de secours</strong> ci-dessous.
        Ils vous permettront d'acc&eacute;der &agrave; votre compte si vous perdez votre application d'authentification.
        <strong>Chaque code ne peut &ecirc;tre utilis&eacute; qu'une seule fois.</strong>
      </p>

      <div class="backup-codes-grid">
        <div class="backup-code" *ngFor="let code of backupCodes; let i = index">
          <span class="code-num">{{ i + 1 }}.</span>
          <code>{{ code }}</code>
        </div>
      </div>

      <button class="btn btn-secondary" (click)="downloadBackupCodes()">
        <i class="fas fa-download"></i> T&eacute;l&eacute;charger les codes
      </button>

      <div class="warning-box">
        <i class="fas fa-exclamation-triangle"></i>
        <span>Ces codes ne seront plus affich&eacute;s apr&egrave;s cette page !</span>
      </div>

      <button class="btn btn-primary" (click)="finishSetup()">
        <i class="fas fa-arrow-right"></i> Acc&eacute;der au Backoffice
      </button>
    </div>

  </div>
</div>
